// Вход в систему
export const AUTH_SUBMIT_SAGA = 'AUTH_SUBMIT_SAGA';
// Проверка токена
export const CHECK_TOKEN_SAGA = 'CHECK_TOKEN_SAGA';
// Получение текущих посетителей зала
export const CURRENT_VISITORS_SAGA = 'CURRENT_VISITORS_SAGA';
// Получение списка заведений
export const ESTABLISHMENT_LIST_SAGA = 'ESTABLISHMENT_LIST_SAGA';
// Завершаем тренировку посетителя
export const CLOSE_WORKOUT_SAGA = 'CLOSE_WORKOUT_SAGA';
// Получение статистики
export const GET_STATISTIC_SAGA = 'GET_STATISTIC_SAGA';
// Получеие абонементов
export const GET_SUBSCRIPTIONS_SAGA = 'GET_SUBSCRIPTIONS_SAGA';
// Редактирование абонемента
export const UPDATE_SUBSCRIPTION_SAGA = 'UPDATE_SUBSCRIPTION_SAGA';
// Обновление посетителя
export const UPDATE_USER_SAGA = 'UPDATE_USER_SAGA';
// Удаление посетителя
export const REMOVE_USER_SAGA = 'REMOVE_USER_SAGA';
// Получение посетителей с совпадением номера телефона или email
export const GET_USERS_FOR_SUBSCRIPTION_FORM_SAGA = 'GET_USERS_FOR_SUBSCRIPTION_FORM_SAGA';
// Получение текущего года и типов занятий для формы добавления абонемента
export const GET_SUBSCRIPTION_DATA = 'GET_SUBSCRIPTION_DATA';
// Добавление нового абонемента
export const ADD_SUBSCRIPTION_SAGA = 'ADD_SUBSCRIPTION_SAGA';
// Обновление информации о заведении
export const UPDATE_ESTABLISHMENT_SAGA = 'UPDATE_ESTABLISHMENT_SAGA';
// Обновление (добавление) типа абонемента
export const UPDATE_SUBSCRIPTION_TYPE_SAGA = 'UPDATE_SUBSCRIPTION_TYPE_SAGA';
// Обновление (добавление) продолжительности абонемента
export const UPDATE_SUBSCRIPTION_DURATION_SAGA = 'UPDATE_SUBSCRIPTION_DURATION_SAGA';
// Обновление (добавление) количества занятий абонемента
export const UPDATE_SUBSCRIPTION_WORKOUTS_SAGA = 'UPDATE_SUBSCRIPTION_WORKOUTS_SAGA';
// Обновление (добавление) ограничений
export const UPDATE_SUBSCRIPTION_CONSTRAINT_SAGA = 'UPDATE_SUBSCRIPTION_CONSTRAINT_SAGA';
// Запрашиваем данные для типа абонемента
export const GET_SUBSCRIPTION_TYPE_SAGA = 'GET_SUBSCRIPTION_TYPE_SAGA';
// Запрашиваем данные для срока действия абонемента
export const GET_SUBSCRIPTION_DURATION_SAGA = 'GET_SUBSCRIPTION_DURATION_SAGA';
// Запрашиваем данные для количества занятий
export const GET_SUBSCRIPTION_WORKOUT_SAGA = 'GET_SUBSCRIPTION_WORKOUT_SAGA';
// Запрашиваем данные для ограничения
export const GET_SUBSCRIPTION_CONSTRAINT_SAGA = 'GET_SUBSCRIPTION_CONSTRAINT_SAGA';
// Удаление типа абонемента
export const REMOVE_SUBSCRIPTION_TYPE_SAGA = 'REMOVE_SUBSCRIPTION_TYPE_SAGA';
// Удаление срока действия абонемента
export const REMOVE_SUBSCRIPTION_DURATION_SAGA = 'REMOVE_SUBSCRIPTION_DURATION_SAGA';
// Удаление количества занятий
export const REMOVE_SUBSCRIPTION_WORKOUT_SAGA = 'REMOVE_SUBSCRIPTION_WORKOUT_SAGA';
// Удаление ограничения
export const REMOVE_SUBSCRIPTION_CONSTRAINT_SAGA = 'REMOVE_SUBSCRIPTION_CONSTRAINT_SAGA';
// Удаление абонемента
export const REMOVE_SUBSCRIPTION_SAGA = 'REMOVE_SUBSCRIPTION_SAGA';
// Получение данных для qr-кода
export const GET_DATA_FOR_QR_SAGA = 'GET_DATA_FOR_QR_SAGA';
// Рассылка сообщений пользователям
export const SEND_MESSAGES_SAGA = 'SEND_MESSAGES_SAGA';
// Получение полной информации о конкретном пользователе
export const GET_USER_INFO_SAGA = 'GET_USER_INFO_SAGA';
// Получение статистики по пользователям
export const GET_USERS_STATISTIC_SAGA = 'GET_USERS_STATISTICS_SAGA';
// Активация абонемента
export const ACTIVATION_SUBSCRIPTION_SAGA = 'ACTIVATION_SUBSCRIPTION_SAGA';
// Сохранение номера ключа (от шкафа)
export const SAVE_KEY_NUMBER_SAGA = 'SAVE_KEY_NUMBER_SAGA';
// Поиск пользователя, у которого был ключ
export const FIND_KEY_NUMBER_SAGA = 'FIND_KEY_NUMBER_SAGA';
// Получение списка тренировок по указанному абонементу
export const GET_WORKOUTS_FROM_CERTAIN_SUBSCRIPTION_SAGA = 'GET_WORKOUTS_FROM_CERTAIN_SUBSCRIPTION_SAGA';
// Получение списка акций
export const GET_PROMO_SAGA = 'GET_PROMO_SAGA';
// Добавление / обновление акции
export const UPDATE_PROMO_SAGA = 'UPDATE_PROMO_SAGA';
// Удаление акции
export const REMOVE_PROMO_SAGA = 'REMOVE_PROMO_SAGA';
// Сохранение настроек для QR-кода заведения
export const SET_QR_SETTINGS_SAGA = 'SET_QR_SETTINGS_SAGA';
// Получение цен
export const GET_PRICE_SAGA = 'GET_PRICE_SAGA';
// Добавление / обновление цены
export const UPDATE_PRICE_SAGA = 'UPDATE_PRICE_SAGA';
// Удаление цены
export const REMOVE_PRICE_SAGA = 'REMOVE_PRICE_SAGA';
// Получение списка тренеров
export const GET_COACHES_SAGA = 'GET_COACHES_SAGA';
// Добавление / обновление тренера
export const UPDATE_COACH_SAGA = 'UPDATE_COACH_SAGA';
// Удаление тренера
export const REMOVE_COACH_SAGA = 'REMOVE_COACH_SAGA';
// Запись разового посещения
export const RECORD_ONE_TIME_WORKOUT_SAGA = 'RECORD_ONE_TIME_WORKOUT_SAGA';
// Получение списка продаж
export const GET_SALES_SAGA = 'GET_SALES_SAGA';
// Получение цены
export const GET_COST_SAGA = 'GET_COST_SAGA';
// Получение продаж в excel файле
export const EXPORT_SALES_TO_EXCEL_SAGA = 'EXPORT_SALES_TO_EXCEL_SAGA';
// Копирование абонемента (создание нового)
export const COPY_SUBSCRIPTION_SAGA = 'COPY_SUBSCRIPTION_SAGA';
// Получение данных для метода оплаты
export const GET_PAYMENT_METHOD_SAGA = 'GET_PAYMENT_METHOD_SAGA';
// Удаление метода оплаты
export const REMOVE_PAYMENT_METHOD_SAGA = 'REMOVE_PAYMENT_METHOD_SAGA';
// Редактирование платежа
export const UPDATE_PAYMENT_SAGA = 'UPDATE_PAYMENT_SAGA';
// Удаление платежа
export const REMOVE_PAYMENT_SAGA = 'REMOVE_PAYMENT_SAGA';
// Возврат средств за абонемент
export const REPAY_MONEY_FOR_SUBSCRIPTION_SAGA = 'REPAY_MONEY_FOM_SUBSCRIPTION_SAGA';
// Добавление / обновление новой записи
export const UPDATE_BOOKING_SAGA = 'UPDATE_BOOKING_SAGA';
// Удаление записи
export const REMOVE_BOOKING_SAGA = 'REMOVE_BOOKING_SAGA';
// Получение списка пользователей для указанной записи
export const GET_BOOKING_USERS_SAGA = 'GET_BOOKING_USERS_SAGA';
// Добавляем нового пользователя в запись
export const ADD_USER_TO_BOOKING_SAGA = 'ADD_USER_TO_BOOKING_SAGA';
// Удаление пользователя из записи
export const REMOVE_USER_FROM_BOOKING_SAGA = 'REMOVE_USER_FROM_BOOKING_SAGA';
// Получаем срок действия неактивированного абонемента
export const GET_SUBSCRIPTION_INACTIVE_DAYS_SAGA = 'GET_SUBSCRIPTION_INACTIVE_DAYS_SAGA';
// Обновление срока действия неактивированных абонементов
export const UPDATE_SUBSCRIPTION_INACTIVE_DAYS_SAGA = 'UPDATE_SUBSCRIPTION_INACTIVE_DAYS_SAGA';
// Смена тренера в тренеровке
export const CHANGE_WORKOUT_COACH_SAGA = 'CHANGE_WORKOUT_COACH_SAGA';
// Получение списка участников семейного абонемента
export const GET_FAMILY_LIST_SAGA = 'GET_FAMILY_LIST_SAGA';
// Обновление участников семейного абонемента
export const UPDATE_SUBSCRIPTION_FAMILY_LIST_SAGA = 'UPDATE_SUBSCRIPTION_FAMILY_LIST_SAGA';
// Удаление тренировки
export const REMOVE_WORKOUT_SAGA = 'REMOVE_WORKOUT_SAGA';
// Смена типа тренировки на странице с тренировками
export const CHANGE_WORKOUT_TYPE_SAGA = 'CHANGE_WORKOUT_TYPE_SAGA';
// Получение информации о скидке
export const GET_DISCOUNT_SAGA = 'GET_DISCOUNT_SAGA';
// Добавление / удаление скидки
export const UPDATE_DISCOUNT_SAGA = 'UPDATE_DISCOUNT_SAGA';
// Удаление скидки
export const REMOVE_DISCOUNT_SAGA = 'REMOVE_DISCOUNT_SAGA';
// Получение списка бонусов
export const GET_GIFTS_SAGA = 'GET_GIFTS_SAGA';
// Получение бонуса по id
export const GET_GIFT_BY_ID = 'GET_GIFT_BY_ID';
// Добавление бонуса
export const UPDATE_GIFT_SAGA = 'UPDATE_GIFT_SAGA';
// Удаление бонуса
export const REMOVE_GIFT_SAGA = 'REMOVE_GIFT_SAGA';
// Получение списка заказанных бонусов
export const GET_GIFTS_ORDERS_SAGA = 'GET_GIFTS_ORDERS_SAGA';
// Подтверждение / отклонение заказа бонуса
export const ACTION_GIFT_ORDER_SAGA = 'ACTION_GIFT_ORDER_SAGA';
// Редактирование стоимости тренировки
export const UPDATE_WORKOUT_COST_SAGA = 'UPDATE_WORKOUT_COST_SAGA';
// Получение списка товаров
export const GET_GOODS_SAGA = 'GET_GOODS_SAGA';
// Добавление / обновление товара
export const UPDATE_GOODS_SAGA = 'UPDATE_GOODS_SAGA';
// Получение товара по id
export const GET_GOODS_BY_ID_SAGA = 'GET_GOODS_BY_ID_SAGA';
// Удаление товара
export const REMOVE_GOODS_SAGA = 'REMOVE_GOODS_SAGA';
// Получение списка групп товаров
export const GET_GROUPS_SAGA = 'GET_GROUPS_SAGA';
// Добавление / обновление группы товаров
export const UPDATE_GROUP_SAGA = 'UPDATE_GROUP_SAGA';
// Получение группы по id
export const GET_GROUP_BY_ID_SAGA = 'GET_GROUP_BY_ID_SAGA';
// Удаление группы
export const REMOVE_GROUP_SAGA = 'REMOVE_GROUP_SAGA';
// Сохранение продажи товара
export const SAVE_GOODS_PURCHASE_SAGA = 'SAVE_GOODS_PURCHASE_SAGA';
// Копирование записи на несколько дней
export const COPY_BOOKING_SAGA = 'COPY_BOOKING_SAGA';
// Копирование записей дня
export const COPY_DAY_BOOKING_SAGA = 'COPY_DAY_BOOKING_SAGA';
// Получение записей на неделю
export const GET_WEEK_BOOKING_SAGA = 'GET_WEEK_BOOKING_SAGA';
// Сохранение токена для оповещений
export const SAVE_WEB_TOKEN_SAGA = 'SAVE_WEB_TOKEN_SAGA';
// Выгрузка клиентской базы в excel
export const EXPORT_USERS_TO_EXCEL_SAGA = 'EXPORT_USERS_TO_EXCEL_SAGA';
// Добавление / обновление задачи
export const UPDATE_TASK_SAGA = 'UPDATE_TASK_SAGA';
// Получение списка задач
export const GET_TASKS_SAGA = 'GET_TASKS_SAGA';
// Получение задачи по id
export const GET_TASK_BY_ID_SAGA = 'GET_TASK_BY_ID_SAGA';
// Удаление задачи
export const REMOVE_TASK_SAGA = 'REMOVE_TASK_SAGA';
// Перемещение задачи в архив
export const ARCHIVE_TASK_SAGA = 'ARCHIVE_TASK_SAGA';
// Копирывание недели с записями
export const COPY_WEEK_BOOKING_SAGA = 'COPY_WEEK_BOOKING_SAGA';
// Перенос данных пользователя по номеру телефона
export const TRANSFER_USER_DATA_SAGA = 'TRANSFER_USER_DATA_SAGA';
// Редактирование прав пользователя
export const SET_USER_PERMISSION_SAGA = 'SET_USER_PERMISSION_SAGA';
// Получение прав пользователя
export const GET_USER_PERMISSION_SAGA = 'GET_USER_PERMISSION_SAGA';
// Отправка уведомлений в записи
export const SEND_BOOKING_NOTIFICATION_SAGA = 'SEND_BOOKING_NOTIFICATION_SAGA';
// Смена даты тренировки
export const CHANGE_WORKOUT_DATE_SAGA = 'CHANGE_WORKOUT_DATE_SAGA';
// Смена даты продажи
export const CHANGE_PAYMENT_DATE_SAGA = 'CHANGE_PAYMENT_DATE_SAGA';
// Заморозка абонемента
export const FREEZE_SUBSCRIPTION_SAGA = 'FREEZE_SUBSCRIPTION_SAGA';
// Удаление тренировки в долг
export const REMOVE_DEBT_WORKOUT_SAGA = 'REMOVE_DEBT_WORKOUT_SAGA';
// Сортировка данных
export const SORT_SAGA = 'SORT_SAGA';
// Подтверждение почты
export const CONFIRM_EMAIL_SAGA = 'CONFIRM_EMAIL_SAGA';
// Отмена группового занятия
export const CANCEL_BOOKING_SAGA = 'CANCEL_BOOKING_SAGA';
// Получение списка товаров для настройки промокода
export const GET_PROMO_GOODS_SAGA = 'GET_PROMO_GOODS_SAGA';
// Обновление списка товаров в настройках промокода
export const UPDATE_PROMO_GOODS_SAGA = 'UPDATE_PROMO_GOODS_SAGA';
// Загрузка файла (документа)
export const UPLOAD_FILE_SAGA = 'UPLOAD_FILE_SAGA';
// Удаление пропущенной тренировки
export const REMOVE_MISSED_WORKOUT_SAGA = 'REMOVE_MISSED_WORKOUT_SAGA';
// Деактивация абонемента
export const DEACTIVATE_SUBSCRIPTION_SAGA = 'DEACTIVATE_SUBSCRIPTION_SAGA';
// Сохранение настроек пользователя
export const SET_USER_SETTINGS_SAGA = 'SET_USER_SETTINGS_SAGA';
// Получение настроек автоматизации
export const GET_AUTOMATION_SAGA = 'GET_AUTOMATION_SAGA';
// Сохранение настроек автоматизации (день рождения)
export const UPDATE_BIRTHDAY_AUTOMATION_SAGA = 'UPDATE_BIRTHDAY_AUTOMATION_SAGA';
// Удаление автоматического поздравления именинников
export const REMOVE_BIRTHDAY_AUTOMATION_SAGA = 'REMOVE_BIRTHDAY_AUTOMATION_SAGA';
// Получение данных администратора по id
export const GET_ADMIN_BY_ID_SAGA = 'GET_ADMIN_BY_ID_SAGA';
// Обновление данных администратора
export const UPDATE_ADMIN_BY_ID_SAGA = 'UPDATE_ADMIN_BY_ID_SAGA';
// Удаление администратора
export const REMOVE_ADMIN_BY_ID_SAGA = 'REMOVE_ADMIN_BY_ID_SAGA';
// Получение списка операций по депозиту
export const GET_DEPOSIT_LIST_SAGA = 'GET_DEPOSIT_LIST_SAGA';
// Обновление депозита
export const UPDATE_DEPOSIT_SAGA = 'UPDATE_DEPOSIT_SAGA';
// Получение депозита по id
export const GET_DEPOSIT_BY_ID_SAGA = 'GET_DEPOSIT_BY_ID_SAGA';
// Удаление депозита
export const REMOVE_DEPOSIT_SAGA = 'REMOVE_DEPOSIT_SAGA';
// Доплата за тренировку
export const WORKOUT_PAYMENT_SAGA = 'WORKOUT_PAYMENT_SAGA';
// Сброс пароля администратору (суперадмином)
export const RESET_ADMIN_PASSWORD_SAGA = 'RESET_ADMIN_PASSWORD_SAGA';
// Сделать абонемент безлимитным / убрать безлимит
export const CHANGE_UNLIM_SUBSCRIPTION_SAGA = 'CHANGE_UNLIM_SUBSCRIPTION_SAGA';
// Смена количества товара на складе
export const UPDATE_GOODS_REST_SAGA = 'UPDATE_GOODS_REST_SAGA';
// Выгрузка остатков в excel
export const EXPORT_GOODS_REST_TO_EXCEL_SAGA = 'EXPORT_GOODS_REST_TO_EXCEL_SAGA';
// Получение данных о зарплатах
export const GET_SALARIES_DATA_SAGA = 'GET_SALARIES_DATA_SAGA';
// Получение таблицы лидеров
export const GET_LEADERBOARD_SAGA = 'GET_LEADERBOARD_SAGA';
// Получение списка доступных абонементов для списания группового занятия
export const GET_AVAILABLE_SUBSCRIPTIONS_SAGA = 'GET_AVAILABLE_SUBSCRIPTIONS_SAGA';
// Списание тренировки на групповое занятие из доступных абонементов
export const ADD_WORKOUT_BY_AVAILABLE_SUBSCRIPTION_SAGA = 'ADD_WORKOUT_BY_AVAILABLE_SUBSCRIPTION_SAGA';
// Получение списка последних записей пользователя
export const GET_LAST_BOOKING_SAGA = 'GET_LAST_BOOKING_SAGA';
// Получение списка детей
export const GET_CHILDREN_SAGA = 'GET_CHILDREN_SAGA';
// Получение ребёнка по id
export const GET_CHILD_BY_ID_SAGA = 'GET_CHILD_BY_ID_SAGA';
// Обновление ребёнка
export const UPDATE_CHILD_SAGA = 'UPDATE_CHILD_SAGA';
// Удаление записе о ребёнке
export const REMOVE_CHILD_SAGA = 'REMOVE_CHILD_SAGA';
// Получение списка отзывов за период
export const GET_REVIEWS_SAGA = 'GET_REVIEWS_SAGA';
// Генерация счёта
export const GENERATE_INVOICE_SAGA = 'GENERATE_INVOICE_SAGA';